import { render, staticRenderFns } from "./commentReply.vue?vue&type=template&id=5bf245d4&scoped=true&"
import script from "./commentReply.vue?vue&type=script&lang=js&"
export * from "./commentReply.vue?vue&type=script&lang=js&"
import style0 from "./commentReply.vue?vue&type=style&index=0&id=5bf245d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf245d4",
  null
  
)

export default component.exports